<template>
  <div class="app-container">
    <div class="filter-container">
      <el-form ref="form" :model="form" label-width="150px">
        <el-form-item label="广场介绍">
          <el-input v-model="form.value.squareIntroduction" placeholder="请输入广场介绍" style="width:600px;" maxlength="50" show-word-limit></el-input>
        </el-form-item>

        <el-form-item label="客服热线">
          <el-input v-model="form.value.customerHotline1" placeholder="请输入客服热线" style="width:600px;" maxlength="20" show-word-limit></el-input>
        </el-form-item>

        <el-form-item label="客服热线">
          <el-input v-model="form.value.customerHotline2" placeholder="请输入客服热线" style="width:600px;" maxlength="20" show-word-limit></el-input>
        </el-form-item>
      </el-form>

      <div style="margin-left: 150px;">
        <el-button type="primary" @click="saveData">保存</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import request from "@/utils/request";
  import { mapGetters } from "vuex";

  export default {
    data() {
      return {
        form:{
          id: "",
          school_id: "",
          key: "",
          value: {
            "squareIntroduction": "",
            "customerHotline1": "",
            "customerHotline2": "",
          },
          remark: "",
        },
      };
    },
    created() {
      this.getKeyValue();
    },
    computed: {
      ...mapGetters(["schools", "school_id","user"]),
    },
    watch: {
      school_id(newVal, oldVal) {
        this.getKeyValue();
      },
    },
    methods: {
      getKeyValue() {
        let key = "customerHotline";
        let remark = "客服热线";
        request({
          url: "/api/backend/keyValue/info",
          method: "get",
          params: {
            school_id: this.school_id,
            key: key,
          }
        }).then(response => {
          if (response.data) {
            this.form = response.data;
            this.form.value = JSON.parse(this.form.value);
          } else {
            this.form = {
              id: "",
              school_id: this.school_id,
              key: key,
              value: {
                "squareIntroduction": "",
                "customerHotline1": "",
                "customerHotline2": "",
              },
              remark: remark,
            }
          }
        });
      },
      saveData() {
        if (!this.school_id) {
          this.$message({
            type: "warning",
            message: "请选择学校"
          });
          return;
        } else {
          this.form.school_id = this.school_id;
        }

        if (!this.form.value.squareIntroduction) {
          this.$message({
            type: "warning",
            message: "请输入广场介绍"
          });
          return;
        }
        if (!this.form.value.customerHotline1 || !this.form.value.customerHotline2) {
          this.$message({
            type: "warning",
            message: "请输入客服热线"
          });
          return;
        }
        let form = JSON.parse(JSON.stringify(this.form));
        form.value = JSON.stringify(form.value);

        request({
          url: "/api/backend/keyValue/save",
          method: "post",
          data: form
        }).then(()=>{
          this.getKeyValue();
          this.$message({
            type: "success",
            message: "保存成功!"
          });
        });
      },
    }
  };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

</style>
